import { observer } from "mobx-react";
import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const PieChart = observer(({ series, total }) => {
  const chartOptions = useMemo(() => {
    return {
      series: series.map((s) => s.data),
      options: {
        chart: {
          type: "donut",
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#24E5A4", "#FF6178"],
        labels: series.map((s) => s.name),
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  customTotal: (w) => {
                    return total;
                  },
                },
              },
            },
          },
        },
      },
    };
  }, [series, total]);
  return (
    <div>
      <ReactApexChart
        key={JSON.stringify(series)}
        options={chartOptions.options}
        series={chartOptions.series}
        type="donut"
      />
    </div>
  );
});

export default React.memo(PieChart);
